<template>
  <el-card shadow="never" class="sidebar-card daily-checkin">
    <template #header>
      <span class="card-title">每日签到</span>
    </template>
    <div class="checkin-body">
      <div v-if="isLogin" class="checkin-stats">
        <span>累计签到 {{ checkinTotalDays }} 天</span>
        <span class="checkin-stats-sep">·</span>
        <span class="checkin-points">
          <span>当前积分</span>
          <el-icon class="checkin-points-icon" :size="18"><Coin /></el-icon>
          <span>{{ points }}</span>
        </span>
      </div>
      <div v-else class="checkin-hint">登录后可签到攒积分</div>
      <el-button
        type="primary"
        class="checkin-btn"
        :loading="checkinLoading"
        :disabled="isLogin && todayCheckin"
        @click="onCheckin"
      >
        {{ checkinButtonLabel }}
      </el-button>
      <div class="checkin-tip">每日签到 +1 积分</div>
    </div>
  </el-card>
</template>

<script>
import { ElMessage } from "element-plus";
import { Coin } from "@element-plus/icons-vue";
import { checkin, getCheckinStatus } from "@/api/checkin";

export default {
  name: "DailyCheckin",
  components: { Coin },
  props: {
    isLogin: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["to-login", "checkin-success"],
  data() {
    return {
      checkinTotalDays: 0,
      points: 0,
      todayCheckin: false,
      checkinLoading: false,
    };
  },
  computed: {
    checkinButtonLabel() {
      if (!this.isLogin) return "登录签到";
      if (this.todayCheckin) return "今日已签到";
      return "立即签到";
    },
  },
  watch: {
    isLogin: {
      handler() {
        this.syncCheckinStatus();
      },
      immediate: true,
    },
  },
  methods: {
    async syncCheckinStatus() {
      if (!this.isLogin) {
        this.checkinTotalDays = 0;
        this.todayCheckin = false;
        this.points = 0;
        return;
      }
      try {
        const res = await getCheckinStatus();
        if (res.data.code === 200) {
          const ret = res.data.data;
          this.checkinTotalDays = Number(ret.totalDays || 0);
          this.todayCheckin = ret.todayCheckin === true || ret.todayCheckin === "true";
          this.points = Number(ret.points || 0);
        }
      } catch (e) {
        console.error("加载签到状态失败:", e);
      }
    },
    async onCheckin() {
      if (!this.isLogin) {
        this.$emit("to-login");
        return;
      }
      if (this.todayCheckin) {
        ElMessage.info("今日已签到");
        return;
      }
      this.checkinLoading = true;
      try {
        const res = await checkin();
        if (res.data.code === 200) {
          await this.syncCheckinStatus();
          this.$emit("checkin-success");
          ElMessage.success("签到成功！+1 积分");
          return;
        }
        ElMessage.error(res.data.msg || "签到失败");
      } catch (e) {
        ElMessage.error(e.response?.data?.msg || "签到失败");
      } finally {
        this.checkinLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.daily-checkin {
  height: var(--home-top-card-height, 192px);
  min-height: var(--home-top-card-height, 192px);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.daily-checkin :deep(.el-card__header) {
  padding: 14px 16px;
}

.daily-checkin :deep(.el-card__body) {
  flex: 1;
  display: flex;
  padding: 12px 16px 16px;
  min-height: 0;
}

.checkin-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
  min-height: 0;
}

.checkin-stats,
.checkin-hint {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  line-height: 1.5;
}

.checkin-stats-sep {
  color: var(--el-text-color-placeholder);
}

.checkin-points {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.checkin-points-icon {
  flex-shrink: 0;
  color: #e6a23c;
}

.checkin-btn {
  width: 100%;
}

.checkin-tip {
  color: var(--el-text-color-secondary);
  font-size: 13px;
}
</style>
